import type { AuthType } from "../../auth/auth";

type Result =
  | {
      canQuery: true;
      groupIds?: string[];
    }
  | {
      canQuery: false;
      message: string;
    };

export const getGroupIdToQueryProc = (authCtx: AuthType["data"]): Result => {
  if (authCtx?.accountType === "GrafferStaffAccount") {
    // groupIdによるfilterの必要なし
    return { canQuery: true };
  }

  if (authCtx?.accountType === "OrgAccount") {
    if (authCtx.roles.includes("Admin")) {
      // groupIdによるfilterの必要なし
      return { canQuery: true };
    }

    if (Array.isArray(authCtx.groupIds) && authCtx.groupIds.length > 0) {
      return { canQuery: true, groupIds: authCtx.groupIds };
    }
  }

  return {
    canQuery: false,
    message: "グループに所属していないため、手続きを閲覧できません。",
  };
};
